
import {defineComponent} from 'vue';
import {userUpdatePwURL, userUpdateURL} from "@/config/app-settings";
import axios from "axios";
import {User} from '@/store';
import ProfileForm from "@/components/form/ProfileForm.vue";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Card from "primevue/card";
import Message from "primevue/message";


export default defineComponent({
  name: 'Profile',
  components: {ProfileForm, Card, Button, InputText, Message},
  data() {
    return {
      showPw: false,
      pw: '',
      pwConfirm: '',
      tmpUserEmail: '',
      editing: false,
      editedUser: {} as User,
      changingPw: false,
      levels: null,
      formKey: 0, // When altered, form is rerendered
      state: 'init' as 'init' | 'submitted' | 'success' | 'error',
    }
  },
  computed: {
    user(): User {
      return this.$store.state.user
    },
    pwMatch(): boolean {
      return this.pw === this.pwConfirm
    },
    pwValid(): boolean {
      return this.pw.length >= 8 && this.pw.trim().length === this.pw.length;
    },
  },
  methods: {
    cancel() {
      this.editedUser = JSON.parse(JSON.stringify(this.user))
      this.editing = false
      this.formKey += 1
    },
    cancelPw() {
      this.pw = ''
      this.pwConfirm = ''
      this.changingPw = false
    },
    setEditedUser(user: User) {
      this.editedUser = JSON.parse(JSON.stringify(user))
    },
    savePassword() {
      axios.put(userUpdatePwURL, {
        email: this.user.email,
        password: this.pw,
      })
          .then(() => {
            this.editing = false;
            this.changingPw = false;
          })
    },
    saveUser() {
      const user: User = {
        personId: this.user.personId,
        email: this.editedUser.email === "" ? this.user.email : this.editedUser.email,
        password: this.editedUser.password,
        firstName: this.editedUser.firstName,
        lastName: this.editedUser.lastName,
        street: this.editedUser.street,
        streetNo: this.editedUser.streetNo,
        zip: this.editedUser.zip,
        city: this.editedUser.city,
        country: this.editedUser.country,
        certificates: this.editedUser.certificates,
        phoneNo: this.editedUser.phoneNo,
        selfEstimation: this.editedUser.selfEstimation,
        imageUploadPermission: this.user.imageUploadPermission,
        restrPublication: this.user.restrPublication,
        userNameRight: this.user.userNameRight,
      }
      axios.put(userUpdateURL, user)
          .then((resp) => {
            this.editing = false
            this.state = 'success'
            this.$store.dispatch('validate', {})
            this.$store.commit('setUser', resp.data)
            // Trigger logout
            if (this.tmpUserEmail !== this.editedUser.email) {
              this.$store.commit('setEmailChanged', true)
              this.$store.dispatch('logout')
              this.$router.push({name: 'Login'})
            }
          }).catch(err => {
              this.state = 'error'
              this.$store.dispatch('validate', err.response.data)
      })
    },
    startEditing() {
      this.changingPw = false
      this.editing = true
    },
    editPassword() {
      this.editing = false
      this.changingPw = true
    },
  },
  beforeMount() {
    this.editedUser = JSON.parse(JSON.stringify(this.user))
    this.tmpUserEmail = this.user.email
  }
});
